<template>
  <div class="honors-container">
    <!-- 顶部标题区 -->
    <div class="page-header">
      <h1>医院荣誉 | 砥砺前行 载誉而归</h1>
      <p>湖南省芦淞区中医骨伤专科医院以专业铸口碑，用实力赢荣誉，守护群众骨伤健康之路</p>
    </div>

    <!-- 荣誉展示板块 -->
    <section class="honors-section">
      <h2>荣誉见证实力</h2>
      <div class="honors-grid">
        <div 
          class="honor-card" 
          v-for="(item, index) in honorsList" 
          :key="index"
          @mouseenter="handleCardHover(item, true)"
          @mouseleave="handleCardHover(item, false)"
        >
          <div class="card-inner" :style="{ backgroundColor: item.bgColor }">
            <!-- <img :src="item.img" alt="荣誉证书" class="honor-img" :style="item.imgStyle" /> -->
            <div class="honor-info">
              <h3 :style="{ color: item.titleColor }">{{ item.title }}</h3>
              <p class="honor-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 荣誉背后的故事板块 -->
    <section class="story-section">
      <h2>荣誉背后的坚守</h2>
      <div class="story-content">
        <!-- <img 
          src="https://picsum.photos/600/400?random=8" 
          alt="医护团队" 
          class="story-img"
          @mouseenter="imgScale = 1.03"
          @mouseleave="imgScale = 1"
          :style="{ transform: `scale(${imgScale})`, transition: 'transform 0.3s ease' }"
        /> -->
        <div class="story-text">
          <p>每一项荣誉，都凝聚着芦淞区中医骨伤专科医院全体医护的心血。从传承中医骨伤诊疗精髓，到引入现代先进技术，我们始终以“守护健康”为初心。</p>
          <p>在党建引领下，党员带头钻研业务、优化服务，用专业医术为患者解除骨伤病痛，以人文关怀温暖就医旅程。这些荣誉，是认可，更是鞭策——未来，我们将继续砥砺前行，为区域骨伤医疗事业再添新彩。</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HospitalHonors',
  data() {
    return {
      // 荣誉列表，可替换为医院真实荣誉证书、牌匾照片及介绍
      honorsList: [
        {
          title: '市级中医特色专科',
          desc: '凭借精湛的中医骨伤诊疗技术与特色疗法，获评市级中医特色专科荣誉',
          // img: 'https://picsum.photos/200/200?random=1',
          imgStyle: { borderRadius: '10px' },
          titleColor: '#dc3545',
          bgColor: '#ffe6e6',
          hoverScale: 1
        },
        {
          title: '百姓信赖医疗机构',
          desc: '因优质服务与良好口碑，荣获“百姓信赖医疗机构”称号',
          // img: 'https://picsum.photos/200/200?random=2',
          imgStyle: { borderRadius: '10px' },
          titleColor: '#198754',
          bgColor: '#e6fce6',
          hoverScale: 1
        },
        {
          title: '党建示范单位',
          desc: '党建与医疗深度融合，发挥党员先锋作用，获评党建示范单位',
          // img: 'https://picsum.photos/200/200?random=3',
          imgStyle: { borderRadius: '10px' },
          titleColor: '#007bff',
          bgColor: '#e6f3ff',
          hoverScale: 1
        },
        {
          title: '医疗质量先进集体',
          desc: '严格质控、规范诊疗，荣获“医疗质量先进集体”荣誉',
          // img: 'https://picsum.photos/200/200?random=4',
          imgStyle: { borderRadius: '10px' },
          titleColor: '#ffc107',
          bgColor: '#fff9e6',
          hoverScale: 1
        }
      ],
      imgScale: 1 // 故事板块图片缩放控制
    }
  },
  methods: {
    handleCardHover(item, isEnter) {
      item.hoverScale = isEnter ? 1.02 : 1;
      item.imgStyle.transform = `scale(${item.hoverScale})`;
      item.imgStyle.transition = 'transform 0.3s ease';
    }
  }
}
</script>

<style scoped>
/* 整体容器：白底、居中、阴影修饰 */
.honors-container {
  width: 85%;
  max-width: 1280px;
  margin: 30px auto;
  background-color: #fff;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
  opacity: 0;
  transform: translateY(25px);
  animation: fadeInUp 0.8s forwards;
}

/* 标题区样式：居中、层次分明 */
.page-header {
  text-align: center;
  margin-bottom: 40px;
}
.page-header h1 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 10px;
}
.page-header p {
  color: #777;
}

/* 荣誉板块通用样式：标题突出、间距合理 */
.honors-section,
.story-section {
  margin-bottom: 50px;
}
.honors-section h2,
.story-section h2 {
  font-size: 1.6rem;
  color: #333;
  border-left: 6px solid #007bff;
  padding-left: 12px;
  margin-bottom: 25px;
}

/* 荣誉网格布局：卡片化、自适应 */
.honors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 30px;
}
.honor-card {
  perspective: 1000px;
}
.card-inner {
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease;
  transform-style: preserve-3d;
  padding: 20px;
  border-radius: 10px;
}
.honor-img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-bottom: 15px;
}
.honor-info h3 {
  margin-bottom: 10px;
  font-size: 1.15rem;
}
.honor-desc {
  color: #666;
  line-height: 1.6;
}

/* 荣誉背后的故事布局：图文并茂 */
.story-content {
  display: flex;
  align-items: center;
  gap: 30px;
  background-color: #f9f9f9;
  padding: 25px;
  border-radius: 8px;
}
.story-img {
  width: 40%;
  height: auto;
  border-radius: 8px;
}
.story-text {
  flex: 1;
  color: #666;
  line-height: 1.7;
}

/* 入场动画：渐变上移 */
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式适配：不同屏幕下布局调整 */
@media (max-width: 992px) {
  .story-content {
    flex-direction: column;
  }
  .story-img {
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>